document.addEventListener("DOMContentLoaded", function () {
  const { template } = document.getElementById("bundle-js").dataset;
  if (template === "custom-bundle") {
    initializeBundleSelection();
  }
  updateBundleImage(template);
  if (template !== "custom-bundle") return;
  const customBundleContainer = document.getElementById("boa-custom-bundle");
  customBundleContainer.addEventListener("click", handleBundleProductClick);

  const bundleForm = document.getElementById("bundle-form");
  bundleForm.addEventListener("submit", handleBundleToCart);
});

window.updateBundleImage = updateBundleImage;

// Update bundle image block
function updateBundleImage(template) {
  const bundleImageContainer = document.getElementById("bundle-block-image");
  if (!bundleImageContainer) return;

  const imageSelector = template === "bundle" 
      ? ".boa-variant-bundle-image-container img"
      : ".boa-bundle-checked img";

  // Clear the container for non-bundle templates
  if (template !== "bundle") {
    bundleImageContainer.innerHTML = "";
  }

  document.querySelectorAll(imageSelector).forEach((img) => {
    bundleImageContainer.appendChild(img.cloneNode(true));
  });
}

function initializeBundleSelection() {
  const customBundleContainer = document.getElementById("boa-custom-bundle");
  const bundleBlocks = customBundleContainer?.querySelectorAll(
    ".boa-custom-bundle-block"
  );

  if (!bundleBlocks){
    return;
  }

  bundleBlocks.forEach((block) => {
    const bundleWrapper = block.querySelector(".boa-custom-bundle-wrapper");
    if (bundleWrapper) {
      bundleWrapper.classList.add("boa-bundle-checked");
    }
  });
}

function handleBundleProductClick(event) {
  const clickedWrapper = event.target.closest(".boa-custom-bundle-wrapper");
  if (!clickedWrapper) {
    return;
  }
  const submitButton = document.getElementById("boa-custon-bundle-button");
  submitButton.classList.remove("boa-custom-bundle-sold-out-button");
  submitButton.innerText = "הוספה לעגלה";
  const bundleBlock = clickedWrapper.closest(".boa-custom-bundle-block");
  const previouslySelected = bundleBlock.querySelector(".boa-bundle-checked");
  if (previouslySelected) {
    previouslySelected.classList.remove("boa-bundle-checked");
  }
  clickedWrapper.classList.add("boa-bundle-checked");
  bundleBlock
    .closest(".boa-custom-bundle-container")
    .querySelector(".boa-custom-bundle-variant-text").innerText =
    clickedWrapper.dataset.variantTitle;

  updateBundleImage();
}

async function handleBundleToCart(event) {
  event.preventDefault();
  const bundleForm = event.target;
  const { bundleTitle,id } = bundleForm.dataset;
    const bundleItems = [];

  bundleForm.querySelectorAll(".boa-bundle-checked").forEach((product) => {
    const { variantId } = product.dataset;
    const bundleItem = {
      variantId: variantId,
      quantity: 1,
    };

    bundleItems.push(bundleItem);
  }); 
  const formData = {
    items: [
      {
        id: id,
        quantity: 1,
        title: bundleTitle,
        properties: {
          _bundleId: bundleItems,
          _productTitle: bundleTitle,
          _productId:id
        },
      },
    ],
  };
  await addToCart(formData);
}

async function addToCart(formData) {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    if (!response.ok) {
      cart.addToCartError();
    } else {
      cart.getCart(); // Redirect or update cart if needed
    }
  } catch (error) {
    cart.addToCartError();
  }
}